import axios from "axios";
import axiosTokenService from "./axiosTokenService";
import { final_url} from "./Configuration";
import axiosWithOutToken from "../Components/axiosWithOutToken";


class SwaranandhraService {
  loginDetails(params) {
    return axiosWithOutToken.post(final_url + "userLogin", params);
  }

  getEntryFormList(params) {
    return axiosTokenService.post(final_url + "userserviceslist", params)
  }
  changepassword(params) {
    return axiosTokenService.post(final_url + "changepassword", params)
  }



  userLogout(params) {
    return axiosTokenService.post(final_url + "Logout", params)
  }

  getCaptcha() {
    return axios.get(final_url + "api/captcha")
  }



  getApprovePendingList(params) {
    return axiosTokenService.post(final_url + "approvePendingList", params)
  }

  getNewIndicatorsApproval(params) {
    return axiosTokenService.post(final_url + "newIndicatorsApproval", params)
  }


  getIndicatorMandalMapping(params) {
    return axiosTokenService.post(final_url + "indicatorMandalMapping", params)
  }

  getDataEntryForProgress(params) {
    return axiosTokenService.post(final_url + "dataEntryForProgress", params)
  }

  getAsoForward(params) {
    return axiosTokenService.post(final_url + "asoForward", params)
  }

  getCpoForward(params) {
    return axiosTokenService.post(final_url + "cpoForward", params)
  }

  getAdForward(params) {
    return axiosTokenService.post(final_url + "adForward", params)
  }

  saveEntryForTarget(params) {
    return axiosTokenService.post(final_url + "dataEntryForTargetssave", params)
  }

  UpdateEntryForTarget(params) {
    return axiosTokenService.post(final_url + "dataEntryForTargetssave", params)
  }

  status_list(params) {
    return axiosTokenService.post(final_url + "status_list", params)
  }

  dataEntryForTargets(params) {
    return axiosTokenService.post(final_url + "dataEntryForTargets", params)
  }
  individualDashboard() {
    return axiosTokenService.get(final_url + "individualDashboard")
  }
  gmdpContributions(params) {
    return axiosTokenService.post(final_url + "gmdpDataEntry", params)
  }
  getProgressreport(params) {
    return axiosTokenService.post(final_url + "progressReport", params)
  }

  activeUsers() {
    return axiosTokenService.post(final_url + "activeUsers");
  }

  userlogoutByManuallyUser(params) {
    return axiosWithOutToken.post(final_url + "userlogoutByManuallyUser", params);
  }

  removeBlockedUsers(params) {
    return axiosWithOutToken.post(final_url + `removeBlockedUsers?userId=${params}`);
  }


  blockedList() {
    return axiosWithOutToken.post(final_url + "blockedList");
  }

  getOtp(params) {
    return axiosWithOutToken.post(final_url + "api/sendotp", params);
  }

  gettargetsAndGmdpForward(params) {
    return axiosTokenService.post(final_url + "targetsAndGmdpForward", params)
  }
  gettargetsAndGmdpReturn(params) {
    return axiosTokenService.post(final_url + "targetsAndGmdpReturn", params)
  }

getVerifyotp(params) {
    return axiosWithOutToken.post(final_url + "api/forgotpassword ",params)
  }

  Relogin(params){
    return axiosTokenService.post(final_url + "relogin	", params)
  }

  getIndicatorwiseReport(params) {
    return axiosTokenService.post(final_url + "indicatorwiseReport",params)
  }

  getsectorwiseReport(params) {
    return axiosTokenService.post(final_url +"sectorwiseReport",params);
  }

  getUnitslist() {
    return axiosTokenService.get(final_url +"getUnits")
  }

  addNewUnit(params) {
    return axiosTokenService.post(final_url +"addNewUnit",params);
  }

  
  getMandalVisionBook(params) {
    return axiosTokenService.post(final_url + "mandalVisionBook",params)
  }


  getViewMandalVisionBook(params) {
    return axiosTokenService.post(final_url + "viewMandalVisionBook",params)
  }

  getGvaTablesdata(params) {
    return axiosTokenService.post(final_url + "getGvaTablesData",params)
  }

  getTargetstablesdata(params) {
    return axiosTokenService.post(final_url + "getTargetsTablesData",params)
  }

  getgeneratepdf(params) {
    return axiosTokenService.post(final_url + "generate-html-table-pdf", params, {
      responseType: 'blob' // Set response type to blob
    });
  }
  
  getTargetWiseindicatorReport(params) {
    return axiosTokenService.post(final_url + "targetWiseindicatorReport",params)
  }

  getStatusOfMandalVisionBook(params) {
    return axiosTokenService.post(final_url + "statusOfMandalVisionBook",params)
  }

  getMndalVisionBookGeneratedStatusReport(params){
    return axiosTokenService.post(final_url + "mandalVisionBookGeneratedStatus",params)
  }

  Pdfpreview(params){
    return axiosTokenService.post(final_url+"generate-html-table-pdf_preview", params, {
      responseType: 'blob' 
    });

  }
  PdfZip(){
    return axiosTokenService.get(final_url+"download-all-pdfs",  {
      responseType: 'blob' 
    });}
}
const swaranandhraServiceInstance = new SwaranandhraService();
export default swaranandhraServiceInstance;
